import { Link } from 'react-router-dom'
import SEO from '../components/SEO'
import PageHero from '../components/PageHero'
import ContactForm from '../components/ContactForm'
import MapEmbed from '../components/MapEmbed'
import SocialIcons from '../components/SocialIcons'
import ScrollReveal from '../components/ScrollReveal'
import { business } from '../data/siteData'
import './Contact.css'

export default function Contact() {
  return (
    <>
      <SEO
        title="Contact Us | AS Elite Gatherings — Marthandam, Tamil Nadu"
        description="Reach AS Elite Gatherings at 2nd Floor, AS Elite, No:114G, Railway Station Road, Marthandam, Tamil Nadu 629165. Call +91 63822 82058 or email aselitegatherings@gmail.com."
        keywords="contact event planner Marthandam, AS Elite Gatherings contact, event management Marthandam address, wedding planner contact Tamil Nadu"
        path="/contact"
      />
      <PageHero
        eyebrow="Get In Touch"
        title="Come say hello"
        text={
          <>
            Have a question before you book? Reach out — we're happy to talk through your
            event, no obligation. Ready to go ahead? Head straight to our{' '}
            <Link to="/booking">booking page</Link>.
          </>
        }
       image="/images/bg/bg9.webp"
      />

      <section className="section">
        <div className="container contact-layout">
          <ScrollReveal direction="left" className="contact-info">
            <div className="contact-info-item">
              <span className="contact-info-label">Visit Us</span>
              {business.addressLines.map((line, i) => (
                <p key={i}>{line}</p>
              ))}
            </div>
            <div className="contact-info-item">
              <span className="contact-info-label">Call Us</span>
              <a href={business.phoneHref}>{business.phone}</a>
            </div>
            <div className="contact-info-item">
              <span className="contact-info-label">Email Us</span>
              <a href={`mailto:${business.email}`}>{business.email}</a>
            </div>
            <div className="contact-info-item">
              <span className="contact-info-label">Follow Us</span>
              <SocialIcons variant="inline" />
            </div>
          </ScrollReveal>

          <ScrollReveal direction="right" delay={100}>
            <ContactForm />
          </ScrollReveal>
        </div>
      </section>

      <section className="section section-alt">
        <div className="container">
          <MapEmbed />
        </div>
      </section>
    </>
  )
}
